// ------------------------------------------------------------------------------
// name: step
// author: mudas
// created: 2024-11-21
// ------------------------------------------------------------------------------

export enum TaskStepStatus {
  Completed,
  Pending,
  NotStarted,
}

export enum StepNode {
  CreateDemand = 'CREATED',
  Apply = 'APPLIED',
  ConfirmProducer = 'CONFIRM_PRODUCER',
  PassDemand = 'ACCEPTED',
  StartSettlement = 'SETTLING',
  ConfirmSettlement = 'SETTLED',
  END = 'END',
  Canceled = 'CANCELED',
}

export interface TaskStep {
  status: TaskStepStatus;
  description: string;
  operator?: string;
  operateTime?: string;
  node: StepNode;
}
